<div class="position-relative my-1" [ngClass]="progressColorClass">
    <progress min="0" max="100" [value]="value" [ngClass]="progressColorClass"
        [attr.aria-label]="'unifiedComponents.progress' | translate: { value: (value | number: '1.0-0') }"></progress>
    <span *ngIf="value > 0" aria-hidden="true" class="position-absolute top-50 start-50 translate-middle text-white">{{value | number: '1.0-0'}}%</span>
</div>